/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { createSelector } from "@reduxjs/toolkit";
import { perpetratorApi } from "./api-slice";
import { IManageBaseListResponse, IManageBaseResponse } from '@bvi/api-interfaces/response/manage-base-data';

export const selectPerpetrator = createSelector(
  (response?: IManageBaseListResponse) => response,
  (response) => (response?.success ? response.payload.data : []),
);

export const selectPerpetratorListResult = () =>
  perpetratorApi.endpoints.getPerpetratorList.select();

export const selectPerpetratorResponse = (data?: IManageBaseResponse) => {
  if (!data?.success) {
    return [];
  }

  return data.payload.data;
};


